"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallToActionArtefact = void 0;
class CallToActionArtefact {
    constructor(data) {
        this.text = null;
        this.textColor = null;
        this.backgroundColor = null;
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.text = data.text;
            this.textColor = data.textColor;
            this.backgroundColor = data.backgroundColor;
        }
    }
}
exports.CallToActionArtefact = CallToActionArtefact;
//# sourceMappingURL=CallToActionArtefact.js.map